import { useComponentModal } from '@/share/components';
import ProjKpiAuditFlowPicker from './proj-kpi-audit-flow-picker';

export const useProjKpiAuditFlowPicker = () => {
    const { openEditor } = useComponentModal();

    const showProjKpiAuditFlowPicker = async (title, modalProps = {}) => {
        return openEditor(title, ProjKpiAuditFlowPicker, {}, {
            fullscreen: false,
            showMaximize: false,
            showMinimize: false,
            width: '70%',
            height: '500px',
            ...modalProps,
        });
    };
    return {
        showProjKpiAuditFlowPicker,
    };
};
